import * as React from 'react';

import { cn } from '@/hen-ui/utils/index';

export interface NativeSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {}

const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, children, ...props }, ref) => (
    <select className={cn(className)} ref={ref} {...props}>
      {children}
    </select>
  ),
);
NativeSelect.displayName = 'NativeSelect';

export interface NativeSelectOptionProps
  extends React.OptionHTMLAttributes<HTMLOptionElement> {}

const NativeSelectOption = React.forwardRef<
  HTMLOptionElement,
  NativeSelectOptionProps
>(({ className, children, ...props }, ref) => (
  <option className={cn(className)} ref={ref} {...props}>
    {children}
  </option>
));
NativeSelectOption.displayName = 'NativeSelectOption';

export { NativeSelect, NativeSelectOption };
